/* "Complétalo" del cajón del carrito: agrega el producto sugerido. Ver snippets/latte-completalo.liquid */
(function () {
  if (window.__latteCompletalo) return;
  window.__latteCompletalo = true;
  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-latte-add]');
    if (!btn) return;
    var card = btn.closest('.latte-cmp__card');
    var input = card && card.querySelector('[data-latte-variant]');
    if (!input || !input.value) return;
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Agregando...';
    try {
      if (window.Shopify && Shopify.actions && Shopify.actions.updateCart) {
        var res = await Shopify.actions.updateCart({
          lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + input.value, quantity: 1 }]
        });
        if (res && res.userErrors && res.userErrors.length) throw new Error(res.userErrors[0].message);
      } else {
        var r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(input.value), quantity: 1 }] })
        });
        if (!r.ok) throw new Error('add failed');
        window.location.reload();
      }
    } catch (err) {
      btn.removeAttribute('aria-busy');
      btn.textContent = 'Agregar';
      console.warn('[latte-completalo]', err);
    }
  });
})();
